import { supabase } from "@/integrations/supabase/client";

export type AssistantMessage = {
  role: "user" | "assistant";
  content: string;
};

export type SymptomAssistantResponse = {
  message: string;
  followUpQuestions: string[];
  urgency: "emergency" | "same_day" | "routine" | "unknown";
  redFlags: string[];
  departments: string[];
  disclaimer: string;
};

export async function requestSymptomAssistance(
  messages: AssistantMessage[]
): Promise<SymptomAssistantResponse> {
  const { data: { session } } = await supabase.auth.getSession();

  if (!session?.access_token) {
    throw new Error("Please sign in to use the health assistant.");
  }

  const { data, error } = await supabase.functions.invoke(
    "symptom-assistant",
    {
      body: { messages },
      headers: {
        Authorization: `Bearer ${session.access_token}`,
      },
    }
  );

  if (error) {
    throw new Error(
      error.message || "The health assistant is temporarily unavailable."
    );
  }

  return data as SymptomAssistantResponse;
}